import { DataGridRequest, PagedResponseType } from "../shared-models/sharedTypes";
import { HelpUsResult } from "./models/helpUsTypes";
import { HttpClient } from "../../helpers";

export const HelpUsService = {
  GetAllHelpUs: async (request: DataGridRequest) => {
    return await HttpClient.post<PagedResponseType<HelpUsResult>>(`/api/HelpUs/GetAllHelpUs`, request);
  }
};
